export const injectToPrototype = () => {
  String.prototype._addEllipsis = function (limit) {
    let retVal = this;

    if (this.length > limit && this.length >= 3 && limit >= 3) {
      retVal = this.slice(0, limit - 3) + '...';
    }

    return retVal;
  };

  String.prototype.isEmpty = function () {
    return this.length === 0 || !this.trim();
  };
};
